import React, { useContext } from 'react';
import {  Box,  Grid,  Heading,  Paragraph,  Page,  PageContent,  Text,  Button,  Image,  ThemeContext,} from 'grommet';
import { useHistory  } from "react-router-dom";

const auth_sso = () => {
    window.location.href = "/login?auth=SSO";
  };
const auth_pass = () => {
    window.location.href = "/login?auth=PASS";
  };

const CallToAction = () => (
  <Box    alignSelf="center"    height={{ min: 'large' }}    pad={{ vertical: 'xlarge' }} className={'login_page_button_box'} >
    <Heading level={2} size="large" margin="none">
    </Heading>
    <Paragraph size="xlarge">
    </Paragraph>
    <Box    alignSelf="center" >
      <Button  secondary  label="HPE Employee Login" onClick={auth_sso} size="large"  margin="10px" />
      <Button  secondary  label="Customers / Partners Login" onClick={auth_pass} size="large" margin="10px" />
    </Box>
  </Box>
);

const PageLogin = () => (
    <section className={'section'} flex="grow" >
      <PageContent className={'login_page'} >
        <CallToAction />
      </PageContent>
    </section>
);
export default PageLogin 